import React from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "../Reuseable/ScrollToTop";
import { NetworkProvider } from "../Context/NetworkProvider";
import CookiePreferences from "../legal/CookiePreferences";

const RootLayout: React.FC = () => {
  return (
    <NetworkProvider>
      <ScrollToTop />
      <Outlet />
      <CookiePreferences />
    </NetworkProvider>
  );
};

export default RootLayout;
